// outros-resources-05 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A quantidade de pontos que o cliente vai ganhar, além da pontuação padrão/por grupo. Colocando 2, significa pontos em dobro.": "La cantidad de puntos que el cliente va a ganar, además de la puntuación estándar/por grupo. Colocando 2, significa puntos duplicados.",
    "Acesso total": "Acceso total",
    "Adicionado em": "Agregado el",
    "Adicionar Imagem de Destaque. A imagem deve ter o tamanho máximo de 3MB. Os formatos aceitos são .jpeg e .png.": "Agregar Imagen Destacada. La imagen debe tener un tamaño máximo de 3MB. Los formatos aceptados son .jpeg y .png.",
    "Adicionar serviço": "Agregar servicio",
    "Algo deu errado: nenhum ponto foi importado!": "Algo salió mal: ¡no se importó ningún punto!",
    "Alguns postos podem usar um código diferente do padrão da rede cadastrado acima. Se nenhum posto for configurado aqui, todos os postos usarão o código padrão automaticamente.": "Algunas estaciones pueden usar un código diferente del estándar de la red registrado arriba. Si no se configura ninguna estación aquí, todas las estaciones usarán el código estándar automáticamente.",
    "Aplicar a todos": "Aplicar a todos",
    "Aplicar código a todos os postos": "Aplicar código a todas las estaciones",
    "Aprovar Todos": "Aprobar Todos",
    "Arquivo não suportado": "Archivo no soportado",
    "Arquivo:": "Archivo:",
    "Atualizar pontuação": "Actualizar puntuación",
    "Atualizar?": "¿Actualizar?",
    "Avaliação do Frentista": "Evaluación del Playero",
    "Avaliações nas Lojas": "Evaluaciones en las Tiendas",
    "Buscar nos comentários": "Buscar en los comentarios",
    "Cadastrar nova enquete de avaliação": "Registrar nueva encuesta de evaluación",
    "Cadastrar novo grupo de postos": "Registrar nuevo grupo de estaciones",
    "Cadastrar novo promoter": "Registrar nuevo promoter",
    "Cadastrar número de WhatsApp": "Registrar número de WhatsApp",
    "Carregando o arquivo...": "Cargando el archivo...",
    "Categoria do Produto": "Categoría del Producto",
    "Cliente (Gestão Click)": "Cliente (Gestão Click)",
    "Com DDD. Ex.: (11) 98765-4321": "Con código de área. Ej.: (11) 98765-4321",
    "Com comentário": "Con comentario",
    "Com que frequência este número recebe o resumo, sem pedir.": "Con qué frecuencia este número recibe el resumen, sin solicitarlo.",
    "Comentário do Usuário": "Comentario del Usuario",
    "Comentários": "Comentarios",
    "Competência (MM/AAAA)": "Mes de facturación (MM/AAAA)",
    "Confira o número": "Revise el número",
    "Confira os campos obrigatórios antes de salvar.": "Revise los campos obligatorios antes de guardar.",
    "Cor": "Color",
    "Corrigir": "Corregir",
    "Criar Etiqueta": "Crear Etiqueta",
    "Criar Produto": "Crear Producto",
    "Cupom Fiscal": "Cupón Fiscal",
    "Cupom ainda não validado": "Cupón aún no validado",
    "Cupom desvalidado com sucesso!": "¡Cupón invalidado con éxito!",
    "Cupom expirado!": "¡Cupón expirado!",
    "Cupom resgatado com sucesso!": "¡Cupón canjeado con éxito!",
    "Código (rede)": "Código (red)",
    "Código da comanda": "Código de la comanda",
    "Código do Produto (padrão da rede)": "Código del Producto (estándar de la red)",
    "Código do cliente ou CPF": "Código del cliente o CPF",
    "Código do frentista": "Código del playero",
    "Código no Posto": "Código en la Estación",
    "Código para os postos abaixo": "Código para las estaciones a continuación",
    "Códigos por Posto": "Códigos por Estación",
    "Desativado": "Desactivado",
    "Desativar Produto": "Desactivar Producto",
    "Desvalidar": "Invalidar",
    "Detalhes da Regra de Limite de Número de Abastecimentos": "Detalles de la Regla de Límite de Número de Cargas de Combustible",
    "Detalhes da regra Intervalo entre Abastecimentos": "Detalles de la regla Intervalo entre Cargas de Combustible",
    "Detalhes da regra limite de pontos": "Detalles de la regla límite de puntos",
    "Digite apenas números": "Ingrese solo números",
    "Editar Etiqueta": "Editar Etiqueta",
    "Editar Pop-up": "Editar Pop-up",
    "Editar Produto": "Editar Producto",
    "Editar enquete de avaliação": "Editar encuesta de evaluación",
    "Editar grupo de postos": "Editar grupo de estaciones",
    "Editar número de WhatsApp": "Editar número de WhatsApp",
    "Editar promoter": "Editar promoter",
    "Editar serviço": "Editar servicio",
    "Ele para de receber e de responder na hora. O cadastro fica no histórico.": "Deja de recibir y de responder de inmediato. El registro queda en el historial.",
    "Encerrante:": "Totalizador:",
    "Enviar Resposta": "Enviar Respuesta",
    "Enxerga": "Ve",
    "Erro ao atualizar os produtos": "Error al actualizar los productos",
    "Erro ao buscar os combustíveis": "Error al buscar los combustibles",
    "Erro ao buscar regras": "Error al buscar reglas",
    "Erro ao salvar regras": "Error al guardar reglas",
    "Erro no upload de imagem": "Error en la carga de imagen",
    "Escolha o abastecimento que vai ser pontuado.": "Elija la carga de combustible que va a ser puntuada.",
    "Escolha postos específicos quando a pessoa não puder ver a rede toda.": "Elija estaciones específicas cuando la persona no pueda ver toda la red.",
    "Escolha um Abastecimento": "Elija una Carga de Combustible",
    "Este número vai receber dados da sua rede sem precisar de senha. Cadastre apenas números de pessoas que você conhece, e confira os dígitos antes de salvar.": "Este número va a recibir datos de su red sin necesidad de contraseña. Registre solo números de personas que usted conoce, y revise los dígitos antes de guardar.",
    "Está correto": "Está correcto",
    "Etiqueta do cliente": "Etiqueta del cliente",
    "Fator": "Factor",
    "Horas entre exibições": "Horas entre exhibiciones",
    "Ignorada": "Ignorada",
    "Imagem removida": "Imagen quitada",
    "Imagem salva": "Imagen guardada",
    "Imagem selecionada": "Imagen seleccionada",
    "Importar arquivo": "Importar archivo",
    "Importar uma planilha com as colunas nessa ordem, independente do nome da coluna: Nome, Código e Pontuação por real": "Importar una planilla con las columnas en este orden, independientemente del nombre de la columna: Nombre, Código y Puntuación por real",
    "Importar uma planilha com as colunas nessa ordem, independente do nome: CPF (com ou sem máscara), Valor dos pontos e Data (DD/MM/AAAA)": "Importar una planilla con las columnas en este orden, independientemente del nombre: CPF (con o sin formato), Valor de los puntos y Fecha (DD/MM/AAAA)",
    "Informações do Pop-up": "Información del Pop-up",
    "Intervalo Mínimo (em Horas)": "Intervalo Mínimo (en Horas)",
    "Intervalo em Horas": "Intervalo en Horas",
    "Intervalo entre Abastecimentos": "Intervalo entre Cargas de Combustible",
    "Limite de Pontos": "Límite de Puntos",
    "Lista de Promoters": "Lista de Promoters",
    "Lista de enquete de avaliação": "Lista de encuesta de evaluación",
    "Litros (Mínimo)": "Litros (Mínimo)",
    "Litros:": "Litros:",
    "Local de troca:": "Lugar de canje:",
    "Marcar todas permissões": "Marcar todos los permisos",
    "Mostrar sempre": "Mostrar siempre",
    "Motivo da suspeita": "Motivo de la sospecha",
    "Nenhum bico encontrado neste posto.": "No se encontró ningún pico en esta estación de servicio.",
    "Nenhuma etiqueta selecionada": "Ninguna etiqueta seleccionada",
    "Nenhuma imagem selecionada": "Ninguna imagen seleccionada",
    "Nota": "Nota",
    "Nova regra de Intervalo entre Abastecimentos": "Nueva regla de Intervalo entre Cargas de Combustible",
    "Nova regra de limite de pontos": "Nueva regla de límite de puntos",
    "Não encontramos abastecimentos recentes pra esse bico.": "No encontramos cargas de combustible recientes para ese pico.",
    "Não possível atualizar um registro": "No fue posible actualizar un registro",
    "Não é possivel o fazer resgate!": "¡No es posible realizar el canje!",
    "Número de Série": "Número de Serie",
    "Número do WhatsApp": "Número de WhatsApp",
    "O arquivo CSV está vazio ou não contém dados válidos para importação.": "El archivo CSV está vacío o no contiene datos válidos para la importación.",
    "O posto é necessário para que se especifique a origem dos pontos.": "La estación de servicio es necesaria para especificar el origen de los puntos.",
    "O que este número enxerga": "Lo que este número ve",
    "Observação: É possível recuperar somente as avaliações que os usuários criaram ou modificaram na última semana (Google Store).": "Observación: Es posible recuperar solamente las evaluaciones que los usuarios crearon o modificaron en la última semana (Google Store).",
    "Os registros abaixo entram em conflito com os já existentes no banco de dados. Escolha se deseja atualizar os registros atuais com os dados importados.": "Los registros a continuación entran en conflicto con los ya existentes en la base de datos. Elija si desea actualizar los registros actuales con los datos importados.",
    "Papel": "Rol",
    "Para tirar o acesso de alguém, use o botão Excluir na lista. O cadastro fica no histórico e o número volta a ficar livre.": "Para quitarle el acceso a alguien, use el botón Eliminar en la lista. El registro queda en el historial y el número vuelve a quedar libre.",
    "Perguntas que só existem para a rede inteira serão recusadas.": "Las preguntas que solo existen para toda la red serán rechazadas.",
    "Pesquisar produto": "Buscar producto",
    "Pode participar de sorteios": "Puede participar en sorteos",
    "Pontos importados com sucesso!": "¡Puntos importados con éxito!",
    "Pontos por CPF": "Puntos por CPF",
    "Pontos por combustível": "Puntos por combustible",
    "Pontos por real": "Puntos por real",
    "Pontuar": "Puntuar",
    "Pontuação por Real": "Puntuación por Real",
    "Pop-up Ativo": "Pop-up Activo",
    "Possíveis fraudes": "Posibles fraudes",
    "Posto (se cadastrado)": "Estación (si está registrada)",
    "Postos c/ código específico": "Estaciones c/ código específico",
    "Potencial fraude": "Fraude potencial",
    "Preview do PopUp": "Vista previa del Pop-up",
    "Produtos de venda": "Productos de venta",
    "Quantidade de Pontos": "Cantidad de Puntos",
    "Quantidade de pontos": "Cantidad de puntos",
    "Quem atender neste número vai receber informações da sua rede. Confira dígito por dígito antes de continuar.": "Quien atienda este número va a recibir información de su red. Revise dígito por dígito antes de continuar.",
    "Quem é": "Quién es",
    "Reconciliação — Gestão Click x Sistema": "Reconciliación — Gestão Click x Sistema",
    "Rede(deixe vazio para usuário Admin)": "Red (deje vacío para usuario Admin)",
    "Regras salvas com sucesso": "Reglas guardadas con éxito",
    "Resgatar e Imprimir": "Canjear e Imprimir",
    "Responder Comentário": "Responder Comentario",
    "Resposta": "Respuesta",
    "Resposta enviada com sucesso!": "¡Respuesta enviada con éxito!",
    "Resumo automático": "Resumen automático",
    "Selecione no máximo 6 produtos para aparecer em destaque": "Seleccione como máximo 6 productos para aparecer destacados",
    "Selecione um arquivo (.csv, .xlsx, .xls)": "Seleccione un archivo (.csv, .xlsx, .xls)",
    "Sem comentário": "Sin comentario",
    "Sem enquetes": "Sin encuestas",
    "Só para você se achar na lista. Ex.: \"João — dono\".": "Solo para que usted se ubique en la lista. Ej.: \"Juan — dueño\".",
    "Tamanho da imagem é maior que o suportado": "El tamaño de la imagen es mayor que el soportado",
    "Tirar o acesso deste número?": "¿Quitar el acceso a este número?",
    "Todas as permissões": "Todos los permisos",
    "Um registro foi atualizado": "Un registro fue actualizado",
    "Usuário da rede": "Usuario de la red",
    "Usuários Deletados da Rede": "Usuarios Eliminados de la Red",
    "Valor: R$": "Valor: R$",
    "move all left": "mover todo a la izquierda",
    "move all right": "mover todo a la derecha",
    "move selected left": "mover selección a la izquierda",
    "move selected right": "mover selección a la derecha",
    "ra.action.close": "ra.action.close",
    "ra.action.save": "ra.action.save",
    "registro ignorado": "registro ignorado",
    "— não cadastrado —": "— no registrado —",
};

export default catalogo;
